import * as React from 'react';
import {Animated, Platform, StyleProp} from 'react-native';

import StageInner, {Props} from './StageInner';

import Frame from '../../../view_models/Frame';

import {animatedViewStyle} from '../../../styles/variables';

import {isAndroid} from '../../../../data/data_stores/net/UserAgent';

interface State {
  frame: Frame;
  fadeOut: boolean;
}

export default class StageBase extends React.Component<Props, State> {
  public static getDerivedStateFromProps(
    nextProps: Readonly<Props>,
    prevState: State,
  ): Partial<State> | null {
    if (prevState.fadeOut) {
      return null;
    }
    if (
      !prevState.fadeOut &&
      nextProps.frame.background == null &&
      prevState.frame.background !== null
    ) {
      return {
        fadeOut: true,
      };
    } else {
      return {
        frame: nextProps.frame.copy(),
      };
    }
  }

  protected animatedViewRef = React.createRef<HTMLDivElement>();
  protected containerStyle: StyleProp<any>;

  private animating = false;

  constructor(props: Props) {
    super(props);
    this.state = {
      frame: props.frame.copy(),
      fadeOut: false,
    };
    this.containerStyle = [
      props.layoutManager.getStageSize(),
      animatedViewStyle,
    ];
  }

  public componentDidUpdate(
    prevProps: Readonly<Props>,
    prevState: Readonly<State>,
  ) {
    if (this.state.fadeOut && prevState.fadeOut !== this.state.fadeOut) {
      this.fadeOut();
    }
  }

  public render(): React.ReactNode {
    const frame = this.getFrame();
    const background = frame.background;
    return (
      <Animated.View
        ref={this.animatedViewRef as any}
        key={background?.background.id}
        style={this.containerStyle}>
        <StageInner
          {...this.props}
          onAfterRenderBackground={this.fadeIn}
          frame={frame}
        />
      </Animated.View>
    );
  }

  protected animate(
    from: number,
    to: number,
    duration: number,
    callback?: () => void,
  ) {}

  protected stopAnimation = () => {};

  private getFrame(): Frame {
    return this.state.frame || this.props.frame;
  }

  private fadeIn = () => {
    if (this.animating) {
      this.stopAnimation();
    }
    this.animating = true;
    const {frame, onAfterRenderBackground} = this.props;
    const command = frame.background;
    const to =
      Platform.OS === 'web' && isAndroid && command?.options.filter ? 0.99 : 1;
    this.animate(0, to, 200, () => {
      if (command) {
        this.animating = false;
        onAfterRenderBackground(command);
      }
    });
  };

  private fadeOut = () => {
    this.animate(1, 0, 200, () => {
      this.setState({frame: this.props.frame.copy(), fadeOut: false});
    });
  };
}
